module.exports = __webpack_public_path__ + "files/73fd836a3fbd03b3aa9ea50246049097.png";